import React from 'react';
import { Box } from '@nimbus-ds/components';
import { BaseAppLayout } from 'App/components/AppLayout';
import EmptyStateFirstSection from './EmptyStateFirstSection';
import EmptyStateSecondSection from './EmptyStateSecondSection';
import EmptyStateThirdSection from './EmptyStateThirdSection';

function EmptyStateArgentinaSkeleton(): JSX.Element {
  return (
    <BaseAppLayout>
      <Box display="flex" flexDirection="column" gap="16" padding="4">
        <EmptyStateFirstSection.Skeleton />
        <EmptyStateSecondSection.Skeleton />
        <EmptyStateThirdSection.Skeleton />
      </Box>
    </BaseAppLayout>
  );
}

export default EmptyStateArgentinaSkeleton;
